(ns frontend.test.search.event
  (:require [re-frame.core :as rf]
            [frontend.test.search.sub :as sub]))

(rf/reg-event-fx
 ::search-by
 (fn [{db :db} [_ v]]
   {:db (-> db
            (assoc-in [::sub/search-query] v))}))

(rf/reg-event-fx
 ::select-hit
 (fn [{db :db} [_ v]]
   {:db (-> db
            (assoc-in [::sub/selected] v))}))
